import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { HelmetProvider } from 'react-helmet-async';

const rootElement = document.getElementById('root');

// Always use createRoot - SSR HTML is only for SEO bots
// React will replace it completely (no hydration)
const root = ReactDOM.createRoot(rootElement);

root.render(
  <HelmetProvider>
    <ThemeProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ThemeProvider>
  </HelmetProvider>
);

// Remove loading overlay and SSR header/footer after React mounts
setTimeout(() => {
  const loadingOverlay = document.getElementById('loading-overlay');
  const ssrHeader = document.getElementById('ssr-header');
  const ssrFooter = document.getElementById('ssr-footer');
  
  if (loadingOverlay) {
    loadingOverlay.classList.add('fade-out');
    setTimeout(() => loadingOverlay.remove(), 300);
  }
  
  // Remove SSR header/footer (React will render its own)
  if (ssrHeader) ssrHeader.remove();
  if (ssrFooter) ssrFooter.remove();
}, 100);